import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';

export function RelativeTimeComponent({value, suffix = true, disableTooltip = false}) {
    const [state, setState] = useState({ difference: 0, output: '' });

    const renderRelativeTime = useCallback(() => {
        const currentTimestamp = moment();
        const oldTimeStamp = moment(value);

        let type;
        const difference = Math.abs(currentTimestamp.diff(oldTimeStamp, 'seconds'));
        const hours = Math.abs(Math.round(currentTimestamp.diff(oldTimeStamp, 'hours', true)));
        if (hours < 24) { // if time less than 24 hrs calculate in hrs, mins & secs
            const secondsDiff = Math.abs(Math.round(currentTimestamp.diff(oldTimeStamp, 'seconds', true)));
            const minutesDiff = Math.abs(Math.round(currentTimestamp.diff(oldTimeStamp, 'minutes', true)));
            if (secondsDiff < 60) {
                type ='seconds';
            } else if (minutesDiff < 60) {
                type = 'minutes';
            } else {
                type = 'hours';
            }
        } else {
            const daysDiff = Math.abs(Math.round(currentTimestamp.startOf('day').diff(oldTimeStamp.startOf('day'), 'days', true)));
            const monthDiff = Math.abs(Math.round(currentTimestamp.startOf('day').diff(oldTimeStamp.startOf('day'), 'months', true)));
            if (daysDiff < 30) {
                type ='days';
            } else if (monthDiff < 12) {
                type = 'months';
            } else {
                type = 'years';
            }
        }
        let time;
        if (hours < 24) { // if time less than 24 hrs calculate in hrs, mins & secs including time.
            time = currentTimestamp.diff(oldTimeStamp, type, true);
        } else {
            time = currentTimestamp.startOf('day').diff(oldTimeStamp.startOf('day'), type, true);
        }
        let output;
        const absoluteTime = Math.round(time);
        if (Math.abs(absoluteTime) === 1) {
            output = `${Math.abs(absoluteTime)} ${type.slice(0, -1)}`;
        } else if (time === 0 || type === 'seconds') {
            output = `a few ${type}`;
        } else {
            output = `${Math.abs(absoluteTime)} ${type}`;
        }
        if (absoluteTime >= 0) {
            output += suffix ? ' ago' : '';
        } else {
            output = `in ${output}`;
        }
        setState({ type, difference, output, time });
    }, [value, suffix])

    useEffect(() => {
        renderRelativeTime();
    }, [value, renderRelativeTime]);

    const getDelayTime = useCallback(() => {
        const { type, time } = state;
        let delay = 0;
        switch(type) {
            case 'seconds':
            case 'minutes':
                delay = 60;
                break;
            case 'hours':
                if (time + 1 === 0) {
                    delay = 60;
                } else {
                    delay = (Math.abs(time - parseInt(time)) || 1) * 60 * 60;
                }
                break
            default: break;
        }
        return delay * 1000;  // convert to milliseconds;
    }, [state])

    useEffect(() => {
        const { type } = state;
        if (['seconds', 'minutes', 'hours'].includes(type)) {
            const timer = setTimeout(() => {
                renderRelativeTime();
              }, getDelayTime());
            return () => clearTimeout(timer);
        }
    }, [renderRelativeTime, state, getDelayTime]);


    return disableTooltip ? <>{state.output}</> : (
        <Tooltip title={moment(value).format('MM/DD/YYYY hh:mm A')}>
            {state.output}
        </Tooltip>
    );
}
